export { default as CmsSimpleStatCards } from './CmsSimpleStatCards';
